import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import ProfileSubnav from './components/ProfileSubnav';
import CurrentProfileProvider from './providers/CurrentProfile/CurrentProfile.provider';
import BossModeBanner from '../Portfolio/subrouters/Seller/subrouters/ListingDetailSeller/subrouters/ListingInformation/components/BossModeBanner';
import { ADMIN_DASHBOARD_ROUTE } from 'data/global';
import UserEnquiryContextContainer from 'components/UserEnquiryContextContainer';

import './Profile.styles.scss';

const ProfileRouter: React.FC = () => {
  const { pathname } = useLocation();

  const isBossMode = pathname.includes(ADMIN_DASHBOARD_ROUTE);
  const isPreferencesPage = pathname.endsWith('/profile');

  const { t } = useTranslation();

  return (
    <CurrentProfileProvider>
      <div className="profile-router">
        {isBossMode && (
          <BossModeBanner description={t('beCarefulEditingCustomerInfo')} />
        )}

        <h1>{t('accountSettings')}</h1>
        <ProfileSubnav isBossMode={isBossMode} />

        {isPreferencesPage && (
          <UserEnquiryContextContainer className="profile-card-container" />
        )}

        <Outlet />
      </div>
    </CurrentProfileProvider>
  );
};

export default ProfileRouter;
